import { AppConstants } from './../../app.constant';
import { Component, OnInit } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: "app-footer",
	templateUrl: '../shell-templates/footer.component.html'
})

export class FooterComponent {

	version: string;
	constructor(
	) {
		this.version = AppConstants.settings.version;
	}

	ngOnInit(): void {
	}
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/footer.component.ts